import {FormikProps} from 'formik';
import React from 'react';
import MyTextField from 'shared/components/MyTextField';
import {WeenatWeatherStationCredentials} from '../models/BaseWeatherStationSchema';

interface WeenatProviderProps {
  formikProps: FormikProps<WeenatWeatherStationCredentials>;
  disable: boolean;
}

const WeenatCredentialsForm: React.FC<WeenatProviderProps> = ({
  formikProps,
  disable,
}) => {
  const {email} = formikProps.values;

  return (
    <>
      <MyTextField
        variant='outlined'
        fullWidth
        name='email'
        label='Email'
        type='email'
        value={email}
        disabled={disable}
      />
    </>
  );
};

export default WeenatCredentialsForm;
